import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function RequirePermission({ permission, role, children }) {
  const { hasPermission, hasRole, isAuthenticated, ready } = useAuth();
  const location = useLocation();

  if (!ready) return null;
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (!hasPermission(permission) || (role && !hasRole(role))) {
    return <Navigate to="/forbidden" replace state={{ from: location, permission }} />;
  }
  return children;
}
